import { YStack } from '@/components/ui/layout/layout';

import type { ReactNode } from 'react';

export const CredentialRequestOverlay = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <YStack
    center
    className="pointer-events-none absolute inset-0 z-10 overflow-y-auto bg-black/50 p-4"
  >
    <YStack
      role="dialog"
      aria-label={label}
      className="pointer-events-auto max-h-full w-full max-w-sm overflow-y-auto rounded-lg shadow-lg"
    >
      {children}
    </YStack>
  </YStack>
);
